"use client";

import { ArrowUpRight } from "lucide-react";

export default function Careers() {
  return (
    <section
      className="w-full px-[3%] lg:px-[5%]
  pt-6 pb-10 md:pt-8 md:pb-14
  -mt-4 md:-mt-6"
    >
      <div className="mx-auto max-w-[1200px] grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
        {/* Left content */}
        <div>
          <h3 className="text-[20px] sm:text-[22px] md:text-4xl leading-tight">
            Careers
          </h3>

          <p className="mt-3 md:mt-4 text-[13.5px] sm:text-[14.5px] md:text-base text-black/70 leading-[1.65]">
            Join us to shape the future of manufacturing and supply chain
            management while building one of your own!
          </p>

          {/* Desktop button: after paragraph (visible md+) */}
          <a
            href="#"
            className="mt-6 hidden md:inline-flex items-center rounded-[30px] bg-[#FDC300] px-[18px] py-[9px] text-[14px] font-semibold text-black shadow-sm hover:brightness-95 transition-all"
          >
            Join us
            <ArrowUpRight className="ml-2 h-4 w-4" />
          </a>
        </div>

        <div className="flex justify-center md:justify-end">
          <div className="grid grid-cols-3 gap-4 md:gap-5">
            {/* BIG LEFT IMAGE */}
            <div className="col-span-2">
              <img
                src="/aboutus/1.jpeg"
                className="w-full h-full aspect-[16/10] rounded-xl object-cover"
              />
            </div>

            {/* RIGHT TOP */}
            <div className="flex flex-col gap-4">
              <img
                src="/aboutus/2.jpeg"
                className="w-full aspect-[4/3] rounded-xl object-cover"
              />

              <img
                src="/aboutus/3.jpeg"
                className="w-full aspect-[4/3] rounded-xl object-cover"
              />
            </div>

            {/* MIDDLE INLINE (2 IMAGES SIDE BY SIDE) */}
            <div className="col-span-2 grid grid-cols-2 gap-4">
              <img
                src="/aboutus/4.jpeg"
                className="w-full aspect-[4/3] rounded-xl object-cover"
              />
              <img
                src="/aboutus/5.jpeg"
                className="w-full aspect-[4/3] rounded-xl object-cover"
              />
            </div>

            {/* RIGHT BOTTOM (attached to right) */}
            <div className="flex justify-end">
              <img
                src="/aboutus/6.jpeg"
                className="w-full aspect-[4/3] rounded-xl object-cover"
              />
            </div>
          </div>
        </div>

        {/* Mobile button: after images only */}
        <div className="md:hidden">
          <a
            href="#"
            className="mt-6 inline-flex items-center rounded-[30px] bg-[#FDC300] px-[18px] py-[9px] text-[14px] font-semibold text-black shadow-sm hover:brightness-95 transition-all"
          >
            Join us
            <ArrowUpRight className="ml-2 h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
